import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { loaderHandler } from "src/lib/loaderHandler";

export const Route = createFileRoute("/_public")({
  component: RouteComponent,
  ssr: true,
  loader() {
    return loaderHandler((ctx) => {
      if (ctx.session?.user) {
        throw redirect({
          to: "/",
        });
      }
    });
  },
});

function RouteComponent() {
  return <Outlet />;
}
